/* globals google */
'use strict';

var map;
var infoWindow;
var markers = [];
var shouldAutoOpenFirst = false;
var mapsInitTimeoutId = null;

var urlHelper = require('../utils/urlHelper');
var googleAutoComplete = require('../components/googleAddressAutocomplete');

const SELECTORS = {
    clearSearchBtn: '.js-clear-storelocator-search',
    storeSearchInput: '.js-store-search'
}

// near the top, after SELECTORS
function getQueryParam(name) {
    var params = new URLSearchParams(window.location.search);
    if (!params.has(name)) return null;
    // decode '+' as space and percent-encoded values
    return decodeURIComponent(params.get(name).replace(/\+/g, ' '));
}

function waitForGoogleReady(maxWaitMs) {
    return new Promise((resolve, reject) => {
        const start = Date.now();
        (function tick() {
            const ready =
                window.google &&
                google.maps &&
                typeof google.maps.Geocoder === 'function' &&
                $('.map-canvas').data('has-google-api');

            if (ready) return resolve();
            if (Date.now() - start > (maxWaitMs || 4000)) return reject(new Error('Google not ready'));
            setTimeout(tick, 50);
        })();
    });
}

function openMarkerAt(index) {
    if (!markers.length) return;
    var m = markers[index] || markers[0];
    if (!m) return;

    // Use the HTML we stored on the marker
    infoWindow.setOptions({ content: m._infoContent });
    infoWindow.open(map, m);

    // Keep the map view sensible
    if (m.position) {
        // If bounds-fit puts us far/zoomed out, nudge in
        if (map.getZoom() < 14 && markers.length > 1) {
            map.setZoom(14);
        }
        map.panTo(m.position);
    }
}

function focusLocation(index) {
  var i = parseInt(index, 10) - 1;
  openMarkerAt(i);
}

/**
 * Uses google maps api to render a map
 */
function maps(opts) {
    var autoOpen = !!(opts && opts.autoOpenFirst);
    infoWindow = new google.maps.InfoWindow();
    markers = [];

    // Init U.S. Map in the center of the viewport
    var latlng = new google.maps.LatLng(SitePreferences.MAP_VIEWPORT_LATITUDE, SitePreferences.MAP_VIEWPORT_LONGITUDE);
    var mapOptions = {
        scrollwheel: false,
        zoom: 4,
        center: latlng,
        mapTypeId: google.maps.MapTypeId.G_NORMAL_MAP,
        mapId: 'stores'
    };

    map = new google.maps.Map($('.map-canvas')[0], mapOptions);
    var mapdivAttr = $('.map-canvas').attr('data-locations');
    if (!mapdivAttr) return; // nothing to render yet

    var mapdiv;
    try { mapdiv = JSON.parse(mapdivAttr); } catch (e) { return; }
    if (!Array.isArray(mapdiv) || !mapdiv.length) return;

    var bounds = new google.maps.LatLngBounds();

    Object.keys(mapdiv).forEach(function (key) {
        var item = mapdiv[key];
        var label = parseInt(key, 10) + 1;
        var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);

        const icon = document.createElement('div');
        icon.innerHTML = '<span style="color: white; font-size: 16px">' + label.toString() + '</span>';

        const pin = new google.maps.marker.PinElement({
            background: '#2f4146',
            borderColor: '#2f4146',
            glyph: icon,
            scale: 1.2
        });

        var marker = new google.maps.marker.AdvancedMarkerElement({
            position: storeLocation,
            map: map,
            title: item.name,
            content: pin.element
        });

        // Build once; reuse for programmatic open
        var infoWindowHtml = $(item.infoWindowHtml);
        infoWindowHtml.find('.store-hours').remove();
        marker._infoContent = infoWindowHtml.get(0).outerHTML;   // 👈 stash html on marker

        marker.addListener('gmp-click', function () {
            infoWindow.setOptions({ content: marker._infoContent });
            infoWindow.open(map, marker);
        });

        markers.push(marker);              // 👈 keep order aligned with results
        bounds.extend(marker.position);
    });

    // Single result: center/zoom and open immediately
    if (mapdiv.length === 1) {
        map.setCenter(markers[0].position);
        if (autoOpen) {
            map.setZoom(17);
            openMarkerAt(0); // open right away
        } else {
            // show the pin but don't force-close zoom; keep whatever default you set
            // (optional) map.setZoom(10);
        }
        return;
    }

    // Multiple: fit bounds, then open the first when map is idle
    if (mapdiv.length > 1) {
        map.fitBounds(bounds);
        if (autoOpen) {
            google.maps.event.addListenerOnce(map, 'idle', function () {
                openMarkerAt(0);
            });
        }
    }
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
    var $resultsDiv = $('.results');
    var $mapDiv = $('.map-canvas');
    var hasResults = data.stores.length > 0;

    if (!hasResults) {
        $('.store-locator-no-results').show();
    } else {
        $('.store-locator-no-results').hide();
    }

    $resultsDiv.empty()
        .data('has-results', hasResults)
        .data('radius', data.radius)
        .data('search-key', data.searchKey);

    if (data.locations && data.locations.length > 0) {
        $mapDiv.attr('data-locations',
            typeof data.locations === 'string'
                ? data.locations
                : JSON.stringify(data.locations)
        );
    }

    if ($mapDiv.data('has-google-api')) {
        maps({ autoOpenFirst: shouldAutoOpenFirst });
        shouldAutoOpenFirst = false; // reset after use
    } else {
        $('.store-locator-no-apiKey').show();
    }

    if (data.storesResultsHtml) {
        $resultsDiv.append(data.storesResultsHtml);
    }
}

/**
 * Get list of all stores if no results
 * @param {String} url - request URL
 * @param {HTMLElement} spinner - spinner
 * @returns {void}
 */
function getAllStores(url, spinner, form) {
    let urlParams = {
        radius: 1000000000,
        isSortAlphabetically: true
    };

    url = urlHelper.appendToUrl(url, urlParams);

    $.ajax({
        url: url,
        type: form.attr('method'),
        data: {},
        dataType: 'json',
        success: function (data) {
            spinner.stop();

            if (!data || !data.stores || !data.stores.length) {
                return;
            }

            updateStoresResults(data);
            $('.select-store').prop('disabled', true);
        }
    });
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @returns {boolean} false to prevent default event
 */
function search(element) {
    shouldAutoOpenFirst = true; // user-initiated search should auto-open
    let dialog = element.closest('.in-store-inventory-dialog');
    let spinner = dialog.length ? dialog.spinner() : $.spinner();
    spinner.start();

    let $form = element.closest('.store-locator');
    let url = $form.attr('action');

    let countryCode = $form.data('country-code') || 'US';

    // fallback: use .js-store-search if [name="postalCode"] is empty
    let inputString =
        $form.find('[name="postalCode"]').val() ||
        $(SELECTORS.storeSearchInput).val() ||
        '';

    if (!inputString.trim()) {
        spinner.stop();
        return false;
    }

    let geoReqObj = {
        address: inputString,
        region: 'US',
        country: countryCode
    };

    googleAutoComplete.geocoding(geoReqObj).then(response => {
        const countryName = [...new Set(response.map(c => c.address_components.filter(
            a => { return a.types.includes('country'); }
        )[0].short_name))];

        if (countryName.length && countryName[0] === 'US') {
            var reqPayload = {
                lat: response[0].geometry.location.lat().toString(),
                long: response[0].geometry.location.lng().toString(),
            };

            $.ajax({
                url: url,
                type: $form.attr('method'),
                data: reqPayload,
                dataType: 'json',
                success: function (data) {
                    spinner.stop();

                    if (data && data.stores && data.stores.length > 0) {
                        updateStoresResults(data);
                        $('.select-store').prop('disabled', true);
                    } else {
                        getAllStores(url, spinner, $form);
                    }

                    return false;
                }
            });
        } else {
            getAllStores(url, spinner, $form);
        }

        spinner.stop();
    }).catch(() => {
        spinner.stop();

        getAllStores(url, spinner, $form);
    });

    return false;
}


module.exports = {
    init: function () {
        var hasStoreParam = new URLSearchParams(window.location.search).has('store');
        try {
            if (!hasStoreParam && navigator.permissions && URL && Urls && Urls.getNearestStore) {
                navigator.permissions.query({ name: 'geolocation' }).then(function (perm) {
                    if (perm && perm.state === 'granted') {
                        var newurl = Urls.getNearestStore;
                        if (typeof newurl === 'string' && newurl && newurl !== window.location.pathname) {
                            // same-origin check
                            try {
                                new URL(newurl, window.location.origin);
                                window.history.pushState({ path: newurl }, '', newurl);
                            } catch (_) {
                                // Intentionally ignored — invalid URL
                            }
                        }
                    }
                }).catch(function(){ /* ignore */ });
            }
        } catch (_) { /* ignore */ }

        if ($('.map-canvas').data('has-google-api')) {
            if (!hasStoreParam) {
                mapsInitTimeoutId = setTimeout(() => { maps({ autoOpenFirst: false }); }, 1000);
            }
        } else {
            $('.store-locator-no-apiKey').show();
        }

        if (!$('.results').data('has-results')) {
            $('.store-locator-no-results').show();
        }

        // enter-to-search (call search directly)
        $('.search-form .form-control').on('keypress', function (e) {
            if (e.which === 13) {
                e.preventDefault();
                const $form = $(this).closest('.store-locator');
                if ($form.length) search($form);
            }
        });

        // focus map on list click (unchanged)
        $(document).on('click', '.store-details', function () {
            var storeno = $(this).closest('.card-body').data('storeno');
            focusLocation(storeno);
        });

        // auto-run when ?store= is present
        var storeQuery = getQueryParam('store');
        if (storeQuery) {
            $(SELECTORS.storeSearchInput).val(storeQuery);
            $(SELECTORS.clearSearchBtn).removeClass('d-none');

            let $form = $('.store-locator').first();
            if ($form.length) {
                if (mapsInitTimeoutId) { clearTimeout(mapsInitTimeoutId); mapsInitTimeoutId = null; }
                shouldAutoOpenFirst = true; // arriving with ?store= should auto-open
                waitForGoogleReady(4000)
                    .then(function () { search($form); })
                    .catch(function () { search($form); });
            }
        }
    },

    detectLocation: function () {
        // clicking on detect location.
        $('.detect-location').on('click', function () {
            $.spinner().start();
            shouldAutoOpenFirst = true; // auto-open when using detect location
            if (!navigator.geolocation) {
                $.spinner().stop();
                return;
            }

            navigator.geolocation.getCurrentPosition(function (position) {
                var $detectLocationButton = $('.detect-location');
                var url = $detectLocationButton.data('action');
                var radius = $('.results').data('radius');
                var urlParams = {
                    radius: radius,
                    lat: position.coords.latitude,
                    long: position.coords.longitude
                };

                url = urlHelper.appendToUrl(url, urlParams);
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $.spinner().stop();
                        updateStoresResults(data);
                        $('.select-store').prop('disabled', true);
                    }
                });
            });
        });
    },

    search: function () {
        $('.store-locator-container form.store-locator').on('submit', function (e) {
            e.preventDefault();
            search($(this));
        });
        $('.store-locator-container .btn-storelocator-search[type="button"]').on('click', function (e) {
            e.preventDefault();
            search($(this));
        });

        $(SELECTORS.storeSearchInput).on('keyup', function() {
            if ($(this).val().length > 0) {
                $(SELECTORS.clearSearchBtn).removeClass('d-none');
            } else {
                $(SELECTORS.clearSearchBtn).addClass('d-none');
            }
        });
    },

    clearSearch: function () {
        $(SELECTORS.clearSearchBtn).on('click', function (e) {
            $(SELECTORS.storeSearchInput).val('');
            e.preventDefault();
            search($(this));
            $(this).addClass('d-none');
        });
    },

    changeRadius: function () {
        $('.store-locator-container .radius').on('change', function () {
            var radius = $(this).val();
            var searchKeys = $('.results').data('search-key');
            var url = $(this).data('action-url');
            var urlParams = {};

            if (searchKeys.postalCode) {
                urlParams = {
                    radius: radius,
                    postalCode: searchKeys.postalCode
                };
            } else if (searchKeys.lat && searchKeys.long) {
                urlParams = {
                    radius: radius,
                    lat: searchKeys.lat,
                    long: searchKeys.long
                };
            }

            url = urlHelper.appendToUrl(url, urlParams);
            var dialog = $(this).closest('.in-store-inventory-dialog');
            var spinner = dialog.length ? dialog.spinner() : $.spinner();
            spinner.start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    spinner.stop();
                    updateStoresResults(data);
                    $('.select-store').prop('disabled', true);
                }
            });
        });
    },
    selectStore: function () {
        $('.store-locator-container').on('click', '.select-store', (function (e) {
            e.preventDefault();
            var selectedStore = $(':checked', '.results-card .results');
            var data = {
                storeID: selectedStore.val(),
                searchRadius: $('#radius').val(),
                searchPostalCode: $('.results').data('search-key').postalCode,
                storeDetailsHtml: selectedStore.siblings('label').find('.store-details').html(),
                event: e
            };

            $('body').trigger('store:selected', data);
        }));
    },
    updateSelectStoreButton: function () {
        $('body').on('change', '.select-store-input', (function () {
            $('.select-store').prop('disabled', false);
        }));
    }
};
